export interface StatusMeta {
  css: string; // pill colour class
  key: string; // i18n translation key
}

// Packages
export const PACKAGE_STATUS_META: Record<number, StatusMeta> = {
  2: { css: 'status-received', key: 'App.Status.received' },
  6: { css: 'status-grey', key: 'App.Status.delivered' },
  16: { css: 'status-new', key: 'App.Status.expired' },
};

export const SUBSCRIPTION_STATUS_META: Record<number, StatusMeta> = {
  0: { css: 'status-pay-per-use', key: 'App.Status.payPerUse' },
  1: { css: 'status-monthly', key: 'App.Status.monthly' },
};

export const PAYMENT_STATUS_META: Record<number, StatusMeta> = {
  1: { css: 'status-pending', key: 'App.PaymentStatus.pending' },
  2: { css: 'status-success', key: 'App.PaymentStatus.paid' },
  3: { css: 'status-danger', key: 'App.PaymentStatus.failed' },
  4: { css: 'status-pending', key: 'App.PaymentStatus.pending' },
  6: { css: 'status-pay-per-use', key: 'App.PaymentStatus.includedInSubscription' },
  7: { css: 'status-refused', key: 'App.PaymentStatus.notApplicable' },
};

export const INVOICE_STATUS_META: Record<number, StatusMeta> = {
  1: { css: 'status-pending', key: 'App.InvoiceStatus.pending' },
  2: { css: 'status-success', key: 'App.InvoiceStatus.paid' },
  3: { css: 'status-danger', key: 'App.InvoiceStatus.failed' },
};

// Helper to turn map into options for filters / selects
export const statusOptions = (meta: Record<number, StatusMeta>) =>
  Object.entries(meta).map(([id, m]) => ({ id: +id, value: m.key }));
